import { HiMiniBolt } from 'react-icons/hi2';
import { PiChatCircle } from 'react-icons/pi';
import { RiWhatsappFill } from 'react-icons/ri';
import { classes } from 'src/modules/shared/utils/styles.util';

interface WhatsAppTemplateIconProps {
  className?: string;
  whatsappClassName?: string;
  whatsappBackgroundClassName?: string;
  boltClassName?: string;
  boltBackgroundClassName?: string;
}

export const WhatsAppTemplateIcon = ({
  className,
  whatsappClassName,
  whatsappBackgroundClassName,
  boltClassName,
  boltBackgroundClassName,
}: WhatsAppTemplateIconProps) => {
  return (
    <span
      className={classes(
        'relative inline-flex h-5 w-5 shrink-0 items-center justify-center',
        className
      )}
      aria-hidden="true"
    >
      <PiChatCircle className="h-full w-full" />

      <span
        className={classes(
          'absolute -right-[0.25rem] -top-[0.1rem] rounded-full bg-whatsapp-50 p-[0.05rem] transition-colors duration-200 group-hover:bg-whatsapp-100 group-active:bg-whatsapp-200',
          whatsappBackgroundClassName
        )}
      >
        <RiWhatsappFill
          className={classes('h-[0.75rem] w-[0.75rem]', whatsappClassName)}
        />
      </span>

      <HiMiniBolt
        className={classes(
          'absolute -bottom-[0.1rem] -right-[0.2rem] h-[0.7rem] w-[0.7rem] rounded-full bg-whatsapp-50 p-[0.02rem] transition-colors duration-200 group-hover:bg-whatsapp-100 group-active:bg-whatsapp-200',
          boltClassName,
          boltBackgroundClassName
        )}
      />
    </span>
  );
};
